import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Box1, Calendar, InfoCircle, Location, User } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { StatusBadge } from "@/components/Atoms";
import { getOrderDisplayFields, orderStatusDisplayMap } from "@/lib/dashboard/orderStatus";
import type { OrderListRowProps } from "./OrderListRow.types";
import * as styles from "./OrderListRow.styles";

export type { OrderListRowProps } from "./OrderListRow.types";

export const OrderListRow = memo(function OrderListRow({ order }: OrderListRowProps) {
  const { t } = useTranslation("home");
  const theme = useTheme();
  const statusDisplay = orderStatusDisplayMap[order.status];
  const { productName, customerName, city, date } = getOrderDisplayFields(order);
  const iconColor = theme.palette.text.secondary;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.field}>
        <Box1 size={18} variant="Linear" color={iconColor} />
        <Typography variant="body2" sx={styles.fieldText}>
          {productName}
        </Typography>
      </Box>

      <Box sx={styles.field}>
        <User size={18} variant="Linear" color={iconColor} />
        <Typography variant="body2" sx={styles.fieldText}>
          {customerName}
        </Typography>
      </Box>

      <Box sx={styles.field}>
        <Calendar size={18} variant="Linear" color={iconColor} />
        <Typography variant="body2" sx={styles.fieldText}>
          {date}
        </Typography>
      </Box>

      <Box sx={styles.field}>
        <Location size={18} variant="Linear" color={iconColor} />
        <Typography variant="body2" sx={styles.fieldText}>
          {city}
        </Typography>
      </Box>

      <Box sx={styles.statusColumn}>
        <InfoCircle size={16} variant="Linear" color={iconColor} />
        <Typography variant="caption" sx={styles.statusLabel}>
          {t("dashboard.orders.statusLabel")}
        </Typography>
        <Box sx={styles.badgeWrap}>
          <StatusBadge
            color={statusDisplay.color}
            size="sm"
            label={t(statusDisplay.labelKey)}
          />
        </Box>
      </Box>

      <Box sx={styles.statusDot(statusDisplay.color)} aria-hidden />
    </Box>
  );
});
